<p-tabView>
  <!--  <p-tabPanel [header]="('TRACKING_USER.BUTTON.USER' | translate)">-->
    <div class="grid">
      <div class="col-12 mt-3 flex align-items-center">


        <div class="col-2">
          <span class="p-float-label">
            <input pInputText id="customer" type="text" [(ngModel)]="filterUserList.user"/>
            <label for="customer" id="user-input-label">{{'TRACKING_USER.FILTER.CUSTOMER' | translate}}</label>
          </span>
        </div>

        <div class="col-2">
          <span class="p-float-label">
            <p-dropdown [options]="actionOptions" [(ngModel)]="selectedAction" id="action" type="text"></p-dropdown>
            <label for="action">{{'TRACKING_USER.FILTER.ACTION' | translate}}</label>
          </span>
        </div>


        <div class="col-2">
          <span class="p-float-label">
            <p-calendar id="beggingDate" [(ngModel)]="dateBegging" [dateFormat]="'dd/mm/yy'" [readonlyInput]="true"
                        [minDate]="yearRange[0]" [maxDate]="dateEnd ? dateEnd : yearRange[1]" [showButtonBar]="true" [showIcon]="true"></p-calendar>
            <label for="beggingDate">{{'TRACKING_USER.FILTER.BEGGING_DATE' | translate}}</label>
          </span>
        </div>

        <div class="col-2">
          <span class="p-float-label">
            <p-calendar id="endDate" [(ngModel)]="dateEnd" [dateFormat]="'dd/mm/yy'" [readonlyInput]="true"
                        [minDate]="dateBegging ? dateBegging : yearRange[0]" [maxDate]="yearRange[1]" [showButtonBar]="true" [showIcon]="true"></p-calendar>
            <label for="endDate">{{'TRACKING_USER.FILTER.END_DATE' | translate}}</label>
          </span>
        </div>



        <div class="col-2">
          <button pButton type="button" [icon]="'fa fa-search'" class="p-button-success"
                  [label]="'TRACKING_USER.BUTTON.RESEARCH' | translate" (click)="filterListUser()">
          </button>
        </div>

        <div class="col-2 text-right">
          <button pButton type="button" [icon]="'fa fa-file-excel-o'" class="p-button-success"
                  [label]="'TRACKING_USER.BUTTON.EXPORTED' | translate" (click)="exportToCSV(columnsDetailsUser, trackingDetailsUserList)">
          </button>
        </div>
      </div>
      <div class="col-12">
        <p-table class="trackingDetailsUserList" [tableStyleClass]="'fixtable'"
                 [rows]="20"
                 [resizableColumns]="true"
                 [value]="trackingDetailsUserList" [columns]="columnsDetailsUser"
                 [paginator]="true" [paginatorPosition]="'top'" [alwaysShowPaginator]="true"
                 [pageLinks]="20" [showPageLinks]="true"
                 [sortField]="sortField" [sortOrder]="defaultSortOrder" [metaKeySelection]="true"
                 [rowHover]="true" [reorderableColumns]="true" [resetPageOnSort]="false">
          <ng-template pTemplate="sorticon" let-sortOrder>
            <span *ngIf="sortOrder === 0"><i class="pi pi-fw pi-sort" aria-hidden="true"></i></span>
            <span *ngIf="sortOrder === 1"><i class="pi pi-fw pi-sort-up" aria-hidden="true"></i></span>
            <span *ngIf="sortOrder === -1"><i class="pi pi-fw pi-sort-down" aria-hidden="true"></i></span>
          </ng-template>

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn>
                <p-sortIcon  [field]="col.field"></p-sortIcon>{{ col.header | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="line-table-purge">
              <td>{{ rowData.userID }}</td>
              <td>{{ "TRACKING_USER.ACTION." + (rowData.action ?? 'UNKNOWN') | translate }}</td>
              <td>{{ (rowData.actionDateTime) | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ rowData.serialSent }}</td>
              <td *ngIf="rowData.serialSent != null && rowData.serialSent > 0">{{ "TRACKING_USER.ACTION." + (rowData.docState ?? 'UNKNOWN') | translate }}</td>
              <td *ngIf="rowData.serialSent == null || rowData.serialSent <= 0">{{ "" }}</td>
              <td>{{ rowData.operName }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
</p-tabView>

